<template>
  <v-container fluid class="pa-0">
    <div class="mytop d-flex justify-space-between mt-3">
      <h1 class="display-1 font-weight-thin ml-4">LoggableLogo</h1>
      <v-btn class="ma-2 mr-4 login" outlined color="indigo" @click.stop="login">Login</v-btn>
    </div>
    <v-row class="mytop pt-10 pb-15">
      <v-col cols="12" sm="6">
        <div :class="['header-phrase', {mobile: onMobile} ]">
          <div>Your Projects.</div>
          <div>Organized.</div>
          <div>Effortless.</div>
          <div class="description mt-7">
            Manage your projects everywhere. Be it invoices, expenses or record your time spent on a
            project. Loggable is your own personal assistant logging all the laborious stuff,
            leaving you to focus on doing the things that make your your business fly!
          </div>
          <div class="my-2">
            <v-btn
              x-large
              color="success"
              dark
              :block="onMobile"
              @click.stop="signupForFree"
            >Signup for free!</v-btn>
          </div>
        </div>
      </v-col>

      <v-col cols="12" sm="6">
        <div :class="{'mt-10': !onMobile}">
          <v-img :aspect-ratio="16/12" :src="require('@/assets/LoggableMacBook2.png')"></v-img>
        </div>
      </v-col>
    </v-row>

    <div class="band-same py-15">
      <v-row class="mytop text-h5 font-weight-medium">
        <v-col cols="12" class="text-center mb-15">
          <v-img
            class="mx-auto my-10"
            :aspect-ratio="16/16"
            :src="require('@/assets/target.svg')"
            max-width="160px"
          ></v-img>
          <div class="text-h3 font-weight-medium mt-14">Focus on what matters most</div>
        </v-col>

        <v-col cols="12" sm="4">
          <div>Manage all project details knowing these are store safely and securely in the Cloud</div>
        </v-col>
        <v-col cols="12" sm="4">
          <div>Keep track of your projects and their progress so you can pay attention where it is needed</div>
        </v-col>
        <v-col cols="12" sm="4">
          <div>Record your time spent on your project items anywhere</div>
        </v-col>
      </v-row>
    </div>

    <div class="py-15">
      <v-row class="mytop">
        <v-col cols="12" class="text-center">
          <v-img
            class="mx-auto my-10"
            :aspect-ratio="16/16"
            :src="require('@/assets/box.svg')"
            max-width="160px"
          ></v-img>
          <div class="text-h3 font-weight-medium">At work, at home, and everywhere in between</div>
        </v-col>

        <v-col cols="12" sm="4">
          <div>Manage all project details safely and securely</div>
        </v-col>
        <v-col cols="12" sm="4">
          <div>Manage all project details safely and securely</div>
        </v-col>
        <v-col cols="12" sm="4">
          <div>Manage all project details safely and securely</div>
        </v-col>
      </v-row>
    </div>

    <div class="band-same my-10 py-10">
      <v-row class="mytop text-h5 font-weight-medium">
        <v-col cols="12" md="8">
          <div class="text-h3 font-weight-medium mt-14">Sign up for Loggable today</div>
          <div
            class="text-h5 font-weight-medium mt-10 pr-10"
          >Capture all you need from anywhere and manage your projects with ease.</div>
        </v-col>
        <v-col cols="12" sm="4">
          <v-btn x-large block color="secondary" @click="loginWithGoogle">
            <!-- <v-icon left>mdi-google</v-icon>Sign up free with Google -->
            <v-img max-width="26px" :src="require('@/assets/google-letter.png')" class="mr-5"></v-img>Sign up free with Google
          </v-btn>
          <div class="my-8 text-center text-h6 font-weight-medium">OR</div>
          <v-form>
            <v-text-field label="Username" prepend-icon="mdi-account-circle" v-model="name" />
            <v-text-field label="EMail" prepend-icon="mdi-email" v-model="email" />
            <v-text-field
              :type="showPassword ? 'text' : 'password'"
              v-model="password"
              label="Password"
              prepend-icon="mdi-lock"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
            />
            <template v-if="error">
              <p class="text-caption font-weight-medium registration-error">{{ error }}</p>
            </template>
            <v-btn
              x-large
              color="success"
              block
              @click.stop="registerEmailUser"
              class="mt-4"
            >Sign up for free!</v-btn>
          </v-form>
        </v-col>
      </v-row>
    </div>

    <div class="mt-15">
      <!-- <hr /> -->
      <v-row class="mytop">
        <v-col cols="12" class="text-center">
          <div class="text-caption font-weight-medium">© 2020 Loggable. All rights reserved.</div>
        </v-col>
      </v-row>
    </div>

    <v-row justify="center">
      <v-dialog v-model="showLoginForm" max-width="350px">
        <DialogLogin :item="obj" />
      </v-dialog>
      <v-dialog v-model="showRegisterForm" max-width="350px">
        <DialogRegister :item="obj" />
      </v-dialog>
    </v-row>
  </v-container>

  <!-- Securely stored in Google Cloud -->
</template>

<script>
import { db } from "../auth";
import { storeprops } from "../store/helpers.js";
import DialogLogin from "../components/dialogs/DialogLogin";
import DialogRegister from "../components/dialogs/DialogRegister";
import {
  signinWithEmailAndPassword,
  signinWithGoogle,
  registerWithEmailAndPassword,
} from "../auth";

export default {
  components: {
    DialogLogin,
    DialogRegister,
  },
  data: () => ({
    showLoginForm: false,
    showRegisterForm: false,
    error: "",
    name: "",
    email: "",
    password: "",
    showPassword: false,
    obj: null,
    value: [423, 446, 675, 510, 590, 610, 760],
    avg: 91,
  }),
  computed: {
    ...storeprops,
    onMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    fontStatement() {
      "header-phrase";
    },
  },
  methods: {
    login() {
      // open the login dialog
      this.showLoginForm = true;
    },
    signupForFree() {
      this.showRegisterForm = true;
    },
    gotoRegister() {
      this.$router.push({ name: "register" });
    },
    loginWithGoogle() {
      signinWithGoogle((err) => this.setError(err));
    },
    registerEmailUser() {
      //this.setError("An error occurred - please try again.");
      registerWithEmailAndPassword(this.email, this.password, (err) => {
        this.setError(err);
      });
    },
    setError(err) {
      this.error = err;
      setTimeout(() => (this.error = ""), 5000);
    },
  },
  created() {
    this.obj = new objDataLogin();
    this.obj.closeDialog = () => {
      this.showLoginForm = false;
      this.showRegisterForm = false;
    };
    this.obj.showRegister = () => {
      this.showLoginForm = false;
      this.showRegisterForm = true;
    };
    this.obj.showLogin = () => {
      this.showLoginForm = true;
      this.showRegisterForm = false;
    };
  },
  mounted() {},
};

class objDataLogin {
  loginWithEmailAndPassword = null;
  signinWithFacebook = null;
  signinWithGoogle = null;
  closeDialog = null;
}
</script>

<style lang="scss">
.section-items {
  flex: 1;
  overflow: auto;
}

.section-line {
  height: 1px;
  width: 100%;
  border-top: 1px solid rgb(231, 231, 230);
  margin-top: -10px;
  margin-bottom: 5px;
}

.v-parallax__content {
  color: black !important;
}
.v-parallax .v-parallax__image-container {
  opacity: 0.6 !important;
}
</style>

<style lang="scss" scoped>
.mytop {
  max-width: 1100px;
  margin: auto;
}

div {
  &.header-phrase {
    font-family: "Soleil_Medium", Helvetica, Arial, sans-serif;
    font-size: 56px;
    font-weight: 700;
    line-height: 72px;
    margin-bottom: 2px;
    color: #000;

    &.mobile {
      font-size: 42px;
      font-weight: 500;
      line-height: 58px;

      .description {
        font-weight: 500;
        font-size: 18px;
        line-height: 28px;
      }
    }

    .description {
      font-family: "Soleil_Light", Helvetica, Arial, sans-serif;
      font-weight: normal;
      font-size: 22px;
      line-height: 32px;
      margin-bottom: 15px;
    }
  }
}

.band-gray {
  background: rgba(211, 211, 211, 0.623);
}

.band-signup {
  background: rgba(217, 241, 197, 0.623);
}

.band-same {
  background: rgb(217 217 218 / 70%);
}

.registration-error {
  color: red;
  padding: 10px;
}
</style>